export default __webpack_public_path__ + "eccc4ec5bed0bc8311ae9d6c5b011a3b.png";